export default __webpack_public_path__ + "static/media/bg-home_xl.d94ba0ea.webp";